export const APP_ROUTES = {
  login: '/login',
  home: '/',
  job: (job: string) => `/jobs/${job}`,
  runs: '/run-history',
  /** The path before the runs list moved to `runs`; it redirects so a saved link still works. */
  legacyRuns: '/runs',
  run: (id: string) => `/runs/${id}`,
  conflicts: '/conflicts',
} as const;
